{
  "title": "Entangle",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level conjuration",
  "level": 1,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Grasping weeds and vines sprout from the ground in a 20-foot square starting from a point within range. For the duration, these plants turn the ground in the area into difficult terrain.",
    "A creature in the area when you cast the spell must succeed on a Strength saving throw or be restrained by the entangling plants until the spell ends. A creature restrained by the plants can use its action to make a Strength check against your spell save DC. On a success, it frees itself.",
    "When the spell ends, the conjured plants wilt away."
  ],
  "spellLists": ["druid", "ranger"]
}
